// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ITXB0Kwh","headerButtons":"WciTKaMx","entityHeaderWatchlist":"mhhhSDhV","styledDrawer":"APBg87sb","legacyDrawer":"F9EG4wsW"};